export const rooms = {
  total: 5,
  room_types: [
    {
      rate_basic: 100,
      rate_min: 100,
      rate_max: 100,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 141,
      package_id: 0,
      rate_id: 281,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 100,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 0,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Double Room with Ocean View and Private Pool',
      room_type_title: 'Room #1',
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'Y',
      room_type_short_title: 'R1',
      room_type_desc:
        'This is a luxurious two-room suite with an ocean view and private large pool. Surrounded by lush gardens, the room offers an exquisite blend of modern and traditionalarchitecture - with all the facilities to make your stay truly memorable. Enjoy expansive views of the ocean from every window and relax in a spacious bathroom with a deep-soak bathtub and separate shower. With complimentary breakfast served in your room each morning, this suite is perfect for couples looking for a truly special getaway.',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
      featured_photo_big:
        'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [
        'Automated teller (ATM)',
        'Lounge',
        'Concierge desk',
        'Safe deposit boxes at front desk',
        'Fax services',
        'Shoe-shine service',
        'Foregin currency exchange',
        'Valet service',
      ],
      not_derived_price: false,
      package_terms: 'test',
    },
    {
      rate_basic: 100,
      rate_min: 100,
      rate_max: 100,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 141,
      package_id: 1,
      rate_id: 281,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 100,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 0,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Double Room with Ocean View and Private Pool',
      room_type_title: 'Room #1',
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'Y',
      room_type_short_title: 'R1',
      room_type_desc:
        'This is a luxurious two-room suite with an ocean view and private large pool. Surrounded by lush gardens, the room offers an exquisite blend of modern and traditionalarchitecture - with all the facilities to make your stay truly memorable. Enjoy expansive views of the ocean from every window and relax in a spacious bathroom with a deep-soak bathtub and separate shower. With complimentary breakfast served in your room each morning, this suite is perfect for couples looking for a truly special getaway.',
      num_beds: '1',
      featured_photo: 'https://picsum.photos/id/513/500/300/',
      featured_photo_big: 'https://picsum.photos/id/513/1000/600/',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: false,
      package_terms: 'test',
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 142,
      package_id: 31,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 142,
      package_id: 32,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 142,
      package_id: 33,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 143,
      package_id: 33,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 145,
      package_id: 33,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'Y',
      room_type_short_title: 'R1',
      room_type_desc:
        'This tariff is partially refundable. If you will be traveling by car, in front of the apartment there is a public parking on the street and it is charge if there is a place, per a day 12 euro. If not 30 m from apartment there is private parking 1h approximately 7 kuna. Other things to note: The breakfast is being served until 11:00. ',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
      is_allowed: true,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 146,
      package_id: 33,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 5,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
      featured_photo_big:
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
      is_allowed: true,
    },
    {
      rate_basic: 120,
      rate_min: 120,
      rate_max: 120,
      guests: {
        adult: [],
        kid: [],
      },
      room_type_id: 147,
      package_id: 33,
      rate_id: 282,
      detailed_rates: [
        {
          date: '2023-05-01',
          rate: 120,
          adults: 0,
          kids: 0,
        },
      ],
      is_derived: 1,
      num_available_now: 0,
      remaining: 5,
      los_min: 1,
      los_max: 0,
      cut_off: 0,
      room_type_name: 'Room #1',
      is_package: 1,
      room_type_title: `Room #1 (Room #1 Lucca's Birthday Month)`,
      bookable_limit: '0',
      max_rooms: 5,
      adults_inBasePrice: '1',
      children_inBasePrice: '0',
      max_guests: '1',
      is_private: 'N',
      room_type_short_title: 'R1',
      room_type_desc: 'Room #1 description in english',
      num_beds: '1',
      featured_photo:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
      featured_photo_big:
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
      other_photos: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      photos_gallery: [
        'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
        'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
        'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1/',
      ],
      featured_photo_alt: '',
      other_photos_alt: [],
      photos_gallery_alt: [],
      features: [],
      not_derived_price: {
        detailed_rates: {
          '2023-05-01': {
            date: '2023-05-01',
            rate: 100,
            adults: 0,
            kids: 0,
          },
        },
        rate_basic: 100,
        rate_max: 100,
        rate_min: 100,
      },
      package_internal_name: 'lucca_birthday',
      package_desc: `It includes the Lucca's Birthday party`,
      package_terms: 'Fully refundable before 13 Nov 2023',
      package_src: null,
      package_src_big: null,
      package_src_alt: null,
    },
  ],
  currency_rate: 1,
  roomsRelation: [],
  unavailable_room_types: [],
  bookable_limit_enabled: 1,
  booking_limit_per_person: false,
  website_source_id: '89',
  ma_rates: false,
};
